import React from "react";
import { Check, EyeOff } from "lucide-react";

export const ANONYMOUS_NAME = "Anonymous";

export const CONDITIONAL_FIELDS = {
  phone: { label: "Phone number", type: "tel", placeholder: "+267 71 234 567", required: true },
  email: { label: "Email address", type: "email", placeholder: "you@company.com", required: true },
  company: { label: "Company", type: "text", placeholder: "Company name", required: false },
  job_title: { label: "Job title", type: "text", placeholder: "Your role", required: false },
};

export const conditionalFields = (q) => (q.fields?.length ? q.fields : ["phone", "email"]);

export function isConditionalComplete(q, v) {
  if (!v || !v.follow_up) return !q.required;
  if (v.follow_up === "No") return true;
  return conditionalFields(q).every((k) => !CONDITIONAL_FIELDS[k]?.required || String(v[k] || "").trim());
}

export function AnonymousToggle({ value, onChange, kiosk }) {
  const on = value === ANONYMOUS_NAME;
  return (
    <button type="button" onClick={() => onChange(on ? "" : ANONYMOUS_NAME)}
      className={`mt-3 inline-flex items-center gap-2 rounded-full border px-4 ${kiosk ? "py-2.5 text-sm md:text-base" : "py-2 text-sm"} transition-colors ${on ? "border-purple-600 bg-purple-50 text-purple-900 font-medium" : "border-gray-200 text-gray-700 hover:border-gray-400"}`}
      data-testid="anonymous-name-btn">
      {on ? <Check size={14} /> : <EyeOff size={14} />}
      {on ? "Staying anonymous" : "Stay anonymous"}
    </button>
  );
}

export function ConditionalContactInput({ q, value, onChange, kiosk }) {
  const v = value && typeof value === "object" ? value : {};
  const pad = kiosk ? "px-5 py-4 text-base md:text-lg rounded-xl" : "px-4 py-3.5 text-base rounded-lg";
  const set = (patch) => onChange({ ...v, ...patch });
  const choose = (ans) => onChange(ans === "Yes" ? { ...v, follow_up: "Yes" } : { follow_up: "No" });

  return (
    <div className={kiosk ? "" : "mt-3"} data-testid={`answer-${q.id}`}>
      <div className="grid grid-cols-2 gap-3 max-w-md">
        {["Yes", "No"].map((opt) => {
          const selected = v.follow_up === opt;
          return (
            <button key={opt} type="button" onClick={() => choose(opt)}
              className={`border-2 ${pad} font-medium transition-colors ${selected ? "border-purple-600 bg-purple-50 text-purple-900" : "border-gray-200 text-gray-800 hover:border-gray-300"}`}
              data-testid={`conditional-${q.id}-${opt.toLowerCase()}`}>
              {opt}
            </button>
          );
        })}
      </div>
      {v.follow_up === "Yes" && (
        <div className="fade-up mt-6 grid sm:grid-cols-2 gap-4" data-testid={`conditional-fields-${q.id}`}>
          {conditionalFields(q).map((k) => {
            const meta = CONDITIONAL_FIELDS[k];
            if (!meta) return null;
            return (
              <label key={k} className="block">
                <span className="text-xs text-gray-500">{meta.label}{meta.required && <span className="text-pink-600"> *</span>}</span>
                <input type={meta.type} required={meta.required} value={v[k] || ""} placeholder={meta.placeholder}
                  onChange={(e) => set({ [k]: e.target.value })}
                  className={`mt-1.5 w-full border border-gray-200 ${pad} outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20`}
                  data-testid={`conditional-field-${k}`} />
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
}
